import { render, staticRenderFns } from "./briefcase-storage-info.html?vue&type=template&id=3467a9b2&scoped=true&"
import script from "./briefcase-storage-info.js?vue&type=script&lang=js&"
export * from "./briefcase-storage-info.js?vue&type=script&lang=js&"
import style0 from "./briefcase-storage-info.scss?vue&type=style&index=0&id=3467a9b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3467a9b2",
  null
  
)

export default component.exports